import React, {memo} from 'react';
import styled from "styled-components";
import {Button} from "semantic-ui-react";
import Info from "../Info.jsx";


export const StyledButton = styled(Button)`
  &.ui.button {
    //min-width: 12.571428571428571rem;
    min-width: 180px;
    display: inline-flex;
    align-items: center;
    padding: 0.5714285714285714rem;
    border-radius: 4px;
    min-height: 50px;
    box-shadow: none !important;
    text-shadow: none !important;
    font-size: 16px;
    margin-right: 8px;
    position: relative;

    .popup {
      &__icon {
        padding-left: 10px;
        padding-right: 10px;
        left: -25px;
        position: absolute;
      }
    }

    & > .button-info {
      position: absolute;
      top: 6px;
      right: 7px;
    }

    & > svg {
      margin-left: 9px;
      margin-right: 23px;
    }

    &.primary:not(.filled):hover {
      color: #135CA9;
      background-color: white;
      border-color: #459EFF;
      
      & > .button-info {
        & > svg {
          & path {
            fill: #459EFF !important;
          }
        }
      }

      & > svg {

        > path[fill="#999999"] {
          fill: #459EFF;
        }
        
        > path[fill="#475566"] {
          fill: #135CA9;
        }

        & g > path[fill="#135CA9"] {
          fill: #135CA9;
        }

        & g > path[fill="#459EFF"] {
          fill: #459EFF;
        }
      }
    }

    &.primary.filled, &.primary.filled:focus {
      background: #135CA9;
      box-shadow: none;

      & > .button-info {
        & > svg {
          & path {
            fill: #ffffff;
          }
        }
      }

      & > svg {
        > path {
          fill: white;
        }
        
        & g > path {
          fill: white;
        }
      }

      & > span {
        text-shadow: none;
      }
    }

    &:not(.filled):not(:hover):not(:focus) {
      color: #939697;
      border-color: #AAAAAA;

      & > svg {
        & g > path[fill="#135CA9"] {
          fill: #475566;
        }

        & g > path[fill="#459EFF"] {
          fill: #999999;
        }
      }

      & > span {
        text-shadow: none;
      }

      &.disabled {
        border-color: #AAAAAA;
        color: #AAAAAA;
      }
    }
  }
`;

const IconButton = ({
                        disabled,
                        name,
                        text,
                        iconId,
                        isSelected,
                        iconWidth = '1.5714285714285714rem',
                        iconHeight = '1.5714285714285714rem',
                        onClick,
                        icon,
                        info
                    }) => (
    <StyledButton
        disabled={!!disabled}
        name={name}
        className={`primary ${isSelected ? 'filled' : ''}`}
        onClick={onClick}
    >
        {
            info && <div className='button-info'>
                <Info
                    {...info}
                />
            </div>
        }
        {icon ? icon : <svg width={iconWidth} height={iconHeight}>
            <use xlinkHref={iconId}/>
        </svg>}
        <span>{text}</span>
    </StyledButton>
);

export default memo(IconButton);


// WEBPACK FOOTER //
// ./App/components/Button/IconButton.jsx